/* eslint-disable no-plusplus */
import { TablePagination } from '@mui/material';
import classNames from 'classnames';
import React from 'react';

const Table = ({ tableInstance, className = 'react-table boxed' }) => {
  const { getTableProps, headerGroups, page, getTableBodyProps, prepareRow, toggleAllPageRowsSelected, setIsOpenAddEditModal } = tableInstance;

  return (
    <>
      <table className={className} {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup, headerIndex) => (
            <tr key={`header${headerIndex}`} {...headerGroup.getHeaderGroupProps()} style={{ borderTop: '1px solid #45A994', borderBottom: '1px solid #45A994' }}>
              {headerGroup.headers.map((column, index) => {
                return (
                  <th
                    key={`th.${index}`}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className={classNames(column.headerClassName, {
                      sorting_desc: column.isSortedDesc,
                      sorting_asc: column.isSorted && !column.isSortedDesc,
                      sorting: column.sortable,
                    })}
                    style={{
                      width: column.width || 'auto',
                      padding: '10px',
                      cursor: 'pointer'
                    }}
                  >
                    {column.render('Header')} {(column.sortable) ? <ion-icon name="swap-vertical-outline"></ion-icon> : ''}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);

            return (
              <tr key={`tr.${i}`} {...row.getRowProps()} className={classNames({ selected: row.isSelected })} style={{ borderBottom: '1px solid #45A994' }}>
                {row.cells.map((cell, cellIndex) => (
                  <td
                    key={`td.${cellIndex}`}
                    {...cell.getCellProps()}
                    onClick={() => {
                      if (cell.column.id === 'name') {
                        toggleAllPageRowsSelected(false);
                        row.toggleRowSelected();
                        setIsOpenAddEditModal(true);
                      } else {
                        row.toggleRowSelected();
                      }
                    }}
                    style={{
                      padding: '10px',
                      width: cell.column.id === 'specificColumnId' ? '200px' : 'auto',
                      backgroundColor: cell.column.id === 'highlightColumnId' ? '#f8f9fa' : 'transparent',
                    }}
                  >
                    {cell.render('Cell')}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
       
      </table>
    </>
  );
};
export default Table;
